<template>
  <div>
    <SiruiSearch
      ref="formItem"
      :query="query"
      :columns="fromColumns"
      :isQueryPanel="true"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    >
    </SiruiSearch>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :data="tableData"
        :buttonList="menuButtonList"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="tableColumn"
        :showToolbar="true"
        show-footer
        :footer-method="footerMethod"
        :valid-config="{ autoPos: true, message: 'inline' }"
        :loading="load"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template>
          <vxe-table-column
            :key="index"
            v-for="(i, index) in tableColumn"
            :title="i.title"
            :field="i?.field"
            align="center"
            :formatter="i.formatter"
          >
            <template v-if="i.children">
              <vxe-table-column
                :key="index"
                v-for="(item, index) in i.children"
                :title="item.title"
                :field="item.field"
                align="center"
                :formatter="item.formatter"
              >
              </vxe-table-column>
            </template>
          </vxe-table-column>
        </template>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import DataBaseAPI from '@/api/dataBase';
  import { formColumn, defaultTableColumn } from './index.js';
  import companyApi from '@/api/masterData/company.js';
  import { formatDate } from '@/utils';
  import moment from 'moment';

  export default {
    name: 'overdueDetailReport',
    props: [],
    data() {
      return {
        tableData: [],
        load: false,
        query: { accountPeriod: null },
        departmentList: [],
        menuButtonList: [],
        companyList1: [],
      };
    },
    computed: {
      tableColumn() {
        return defaultTableColumn(this);
      },
      fromColumns() {
        return formColumn(this);
      },
    },
    mounted() {
      const newData = new Date();
      this.query.accountPeriod = moment(
        formatDate(new Date(newData.setDate(newData.getDate() - 30)), true)
      ).format('YYYY-MM');
      this.getButtonList();
      this._getCompanyApi1();
      this.getTableData();
      //   this.getDepartment(this.userInfo.companyCode);
      this.$refs.siruiTable.setPageNum(1);
      this.$refs.siruiTable.setPageSize(10);
      this.$refs.formItem.toggle();
      //   this.query.contractBusinessDepartment = this.userInfo.departmentCode;
    },
    methods: {
      formatterNum({ cellValue }) {
        if (!cellValue && isNaN(cellValue)) return null;
        return this.$utils.commafy(this.$utils.toNumber(cellValue), { digits: 2 });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          // this.getColumnInfo();
        });
      },
      // 导出
      async exportHandler() {
        this.exportExcel();
      },
      chooseClick(type) {
        try {
          console.log(type);
          this[type]();
        } catch (e) {
          console.error('当前方法不支持', e);
          this.$message.error(`${type}当前方法不支持,请联系开发人员`);
        }
      },
      // 平台公司
      async _getCompanyApi1() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const { data } = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (data.code === 0) {
          // 获取公司下拉
          console.log(data.data.personCompanyInfo, '111====>1');
          this.companyList1 =
            data.data.personCompanyInfo.map((item) => {
              return {
                label: item.personCompanyName,
                value: item.personCompanyCode,
              };
            }) || [];
        } else {
          console.error('获取公司失败');
        }
        // const { data } = await this.$axios.get(
        //   `${DataBaseAPI.LISTDATA_SERECHCOMPANY}/${this.userInfo.tenantCode}`
        // );
        // if (data.code == 0) {
        //   this.companyList1 = Object.freeze(data.data);
        // } else {
        //   console.error('获取公司失败');
        // }
      },
      // 根据平台公司code获取全部的部门
      async _getDepartment(companyCodeList) {
        const { data } = await this.$axios.post(
          companyApi.GET_COMPANY_INFO_BY_CODE,
          companyCodeList
        );
        if (data.code == 0) {
          // departmentList
          console.log(data);
          this.departmentList = data.data.map((item) => {
            return {
              value: item.createDepartmentCode,
              label: item.concatCompanyName,
            };
          });
        } else {
          console.error('根据公司code获取部门失败');
        }
      },
      changeMethod({ prop, val }) {
        console.log(prop, val, '切换');
        const rowData = (val && Array.isArray(val) && val[0]) || {};
        console.log(rowData);
        if (prop == 'platformCompanyCodeList') {
          console.log(val, '===??');
          if (val.length) {
            this._getDepartment(val);
          } else {
            this.departmentList = [];
            this.query.businessDepartmentNoList = [];
          }
        } else if (prop == 'businessDepartmentNoList') {
          this.query.businessDepartmentNoList = val;
        } else if (prop == 'projectName') {
          this.query.projectName = val[0].projectName;
          this.query.projectInitiationNo = val[0].projectInitiationNo;
        } else if (prop == 'customerNo') {
          this.query.customerNo = val[0].partnerCode;
        }
      },
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.getTableData();
      },
      searchBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.getTableData();
      },
      // 搜索按钮
      searchTrigger() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      chooseForm(val, type) {
        console.log(val);
        if (type == 'projectNo') {
          const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
          this.query.projectNo = rowData.projectInitiationNo;
        } else if (type == 'purchaseContractNoLike') {
          const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
          this.query.purchaseContractNoLike = rowData.contractNo;
        } else if (type == 'salesContractNoLike') {
          const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
          this.query.salesContractNoLike = rowData.contractNo;
        }
      },
      async exportExcel() {
        // this.query.contractBusinessDepartment = '';
        const { data } = await this.$axios.post('/financial/statistic/overdueCollection/export', {
          ...this.query,
        });
        if (data.code === 0) {
          this.$message({
            showClose: true,
            message: data.msg,
            type: 'success',
          });
          // console.log(data.data);
          window.location.href = data.data.word;
        } else {
          this.$alert(data.msg);
        }
        console.log('导出');
      },
      handleSizeChange() {
        this.getTableData();
      },
      handleCurrentChange() {
        this.getTableData();
      },

      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '小计';
            }
            if (column.property === 'periodEndBalance') {
              const total = data.reduce((cur, next) => cur + +next.periodEndBalance, 0).toFixed(2);
              return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
            }
            if (column.property === 'totalCollection') {
              const total = data.reduce((cur, next) => cur + +next.totalCollection, 0).toFixed(2);
              return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
            }
            if (column.property === 'overdueCollection') {
              const total = data.reduce((cur, next) => cur + +next.overdueCollection, 0).toFixed(2);
              return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
            }
            if (column.property === 'increaseOverdue') {
              const total = data.reduce((cur, next) => cur + +next.increaseOverdue, 0).toFixed(2);
              return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
            }
            if (column.property === 'overdueAmount') {
              const total = data.reduce((cur, next) => cur + +next.overdueAmount, 0).toFixed(2);
              return this.$utils.commafy(this.$utils.toNumber(total), { digits: 2 });
            }
            console.log(column.property);

            return null;
          }),
        ];
      },
      async getDepartment(companyCode) {
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const { data } = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (data.code == 0) {
            this.departmentList = data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      async getTableData() {
        this.load = true;
        let params = {
          ...this.query,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        params.projectName && delete params.projectName;
        const { data } = await this.$axios.post(
          '/financial/statistic/overdueCollection/page',
          params
        );
        this.load = false;
        console.log('data', data);
        if (data.code == 0) {
          this.tableData = data.data.records.map((item) => {
            return {
              ...item,
              enterpriseType: this.dictListMap.enterprise_type?.find(
                (item1) => item1.value == item.enterpriseType
              )?.label,
              overdueFlag: item.overdueFlag ? '是' : '否',
            };
          });
          // this.tableData = data.data;
          this.$refs.siruiTable.setPageTotal(data.data.total);
        }
      },
    },
    components: {},
    watch: {},
  };
</script>

<style lang="scss" scoped></style>
